<template>
  <div>
    <b-row class="match-height">
      <b-col
        v-if="upcomingWfh.length"
        cols="12"
        lg="6"
        xl="6"
        class="mb-2 p-0"
      >
        <div class="total-project-hour-dashboard dashtextShadow">
          <div class="d-flex align-items-start justify-content-between">
            <div>
              <h3 class="mb-0 total-hours-time upcoming-leave-title">
                Upcoming WFH
              </h3>
            </div>
          </div>
          <div class="hr-line-dashboard" />

          <div class="all-project-progress">
            <table class="w-100">
              <thead class="upcoming-head">
                <tr>
                  <th class="w-50">
                    Employee Name
                  </th>
                  <th>Date</th>
                  <th v-if="upcomingWfh[0].hasOwnProperty('is_full_day')">
                    WFH Type
                  </th>
                  <th>WFH Status</th>
                </tr>
              </thead>
              <tbody class="upcoming-body m-50">
                <tr
                  v-for="wfh, index in upcomingWfh"
                  :key="index"
                  class=""
                >
                  <td>
                    <div class="d-flex align-items-center">
                      <b-avatar
                        :text="(wfh.first_name + ' ' + wfh.last_name).split(' ').slice(0, 2).join(' ') | avatarText
                        "
                        :variant="randomVariant(1, upcomingWfh.length)"
                        class="mr-50"
                      />

                      <p
                        class="tbltxtWrap cursor-pointer"
                        @click="openUserProfile(wfh.emp_id)"
                      >
                        {{ wfh.first_name + ' ' + wfh.last_name }}

                      </p>
                    </div>
                  </td>
                  <td>{{ wfh.date | formatDateDDMMYYYY }}</td>
                  <td v-if="wfh.hasOwnProperty('is_full_day')"> <b-badge
                    pill
                    variant="success"
                    class="p-75"
                  >
                    {{ wfh.is_full_day ? 'Full Day' : 'Half Day' }}
                  </b-badge></td>
                  <td> <b-badge
                    pill
                    variant="success"
                    class="p-75"
                  >
                    {{ wfh.is_auto_approved ? 'Auto Approved' : wfh.is_approved ? 'Approved' : null }}
                  </b-badge></td>

                </tr>
              </tbody>
            </table>

          </div>
        </div>
      </b-col>

      <b-col
        v-if="todayWfh.length"
        cols="12"
        lg="6"
        xl="6"
        class="mb-2 pr-0"
      >
        <div class="total-project-hour-dashboard dashtextShadow">
          <div class="d-flex align-items-start justify-content-between">
            <div>
              <h3 class="mb-0 total-hours-time upcoming-leave-title">
                Today's WFH

              </h3>
            </div>
          </div>
          <div class="hr-line-dashboard" />

          <div class="all-project-progress">
            <table class="w-100">
              <thead class="upcoming-head today-leave">
                <tr>
                  <th>
                    Employee Name
                  </th>
                  <th v-if="todayWfh[0].hasOwnProperty('is_full_day')">
                    WFH Type
                  </th>

                </tr>
              </thead>
              <tbody class="upcoming-body m-50">
                <tr
                  v-for="wfh, index in todayWfh"
                  :key="index"
                  class=""
                >
                  <td>
                    <div class="d-flex align-items-center">
                      <b-avatar
                        :text="(wfh.name).split(' ').slice(0, 2).join(' ') | avatarText
                        "
                        :variant="randomVariant(1, todayWfh.length)"
                        class="mr-50"
                      />
                      <p
                        class="tbltxtWrap cursor-pointer"
                        @click="openUserProfile(wfh.emp_id)"
                      >
                        {{ wfh.name }}

                      </p>
                    </div>
                  </td>
                  <td v-if="wfh.hasOwnProperty('is_full_day')"> <b-badge
                    pill
                    variant="success"
                    class="p-75"
                  >
                    {{ wfh.is_full_day ? 'Full Day' : 'Half Day' }}
                  </b-badge></td>
                  <td>{{ wfh.date | formatDateDDMMYYYY }}</td>
                </tr>
              </tbody>
            </table>

          </div>
        </div>
      </b-col>

    </b-row>
  </div>
</template>
<script>
import upComingWfhMixin from '../../../mixin/clockInOut/upComingWfhMixin'

export default {
  name: 'ClockInOutActivityWfh',
  components: {},
  mixins: [upComingWfhMixin],
  props: {
    userId: {
      type: String,
      required: false,
      default: null,
    },
  },
}
</script>
<style lang="scss">
@import './upComingWfh.scss';
</style>
